import { render, staticRenderFns } from "./del_wjdc.vue?vue&type=template&id=8913ebb2&scoped=true&"
import script from "./del_wjdc.vue?vue&type=script&lang=js&"
export * from "./del_wjdc.vue?vue&type=script&lang=js&"
import style0 from "./del_wjdc.vue?vue&type=style&index=0&id=8913ebb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8913ebb2",
  null
  
)

export default component.exports